import { Button } from "@carbon/react";
import { generateUID } from "../utils/generateUID";

export const agentListMapper = (list, t, setOpenModal, setSelectedAgent) => {
  if (!Array.isArray(list) || list.length === 0) {
    return { headers: [], rows: [] };
  }

  let headers = Object.keys(list[0])
    .filter((key) => key !== "id")
    .map((key) => ({
      header: `admin.agentsList.table.${key}`,
      key: key,
    }));

  headers.push({
    header: `admin.agentsList.table.action`,
    key: "action",
  });

  return {
    headers,
    rows: list.map((item) => {
      const row = {};

      row.id = String(item.id ?? generateUID());

      Object.keys(item).forEach((key) => {
        if (key === "id") return;

        if (item[key] == null) {
          row[key] = "-";
        } else if (key === "lastFullReq") {
          const date = new Date(item[key]);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          const hh = String(date.getHours()).padStart(2, "0");
          const min = String(date.getMinutes()).padStart(2, "0");

          row[key] = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
        } else {
          row[key] = item[key];
        }
      });

      row.action = (
        <span className="indicator_cell">
          <Button
            size="sm"
            kind="ghost"
            onClick={() => {
              setOpenModal(true);
              setSelectedAgent(item);
            }}
          >
            {t("admin.agentsList.table.actionText")}
          </Button>
        </span>
      );

      return row;
    }),
  };
};
